import styled from 'styled-components';

export const ChatContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    background: ${props => props.theme.colors.white};
    border-radius: 10px;
    overflow: hidden;

    /* Message container styling */
    & #chat-content {
        width: 100%;
    }

    & #chat-content > div[itemtype="sent"] {
        justify-content: flex-end;
        display: flex;
        width: 100%;
        margin-bottom: 8px;
    }

    & #chat-content > div[itemtype="received"] {
        justify-content: flex-start;
        display: flex;
        width: 100%;
        margin-bottom: 8px;
    }
    
    /* Sent message bubble styling */
    & > #chat-content > div[itemtype="sent"] div:last-child[itemtype="sent"] {
        background: ${props => props.theme.colors.activeBlue || '#2173FF'};
        border-radius: 18px 18px 4px 18px;
        padding: 8px 12px;
        color: ${props => props.theme.colors.white || '#FFFFFF'};
        width: auto;
        max-width: 85%;
        box-shadow: none;
        position: relative;
        min-height: 40px;
    }
    
    /* Received message bubble styling */
    & > #chat-content > div[itemtype="received"] div:last-child[itemtype="received"] {
        background: ${props => props.theme.colors.primaryWhite || '#F5F7FA'};
        border-radius: 18px 18px 18px 4px;
        padding: 8px 12px;
        color: ${props => props.theme.colors.text || '#242424'};
        width: auto;
        max-width: 85%;
        box-shadow: none;
        position: relative;
        border: none;
        min-height: 40px;
    }

    /* Message content styling */
    & #chat-content p {
        margin: 0 0 4px 0;
        line-height: 1.4;
    }

    /* Time display styling */
    & #chat-content .message-time {
        font-size: 11px;
        opacity: 0.7;
        margin-top: 4px;
        text-align: right;
    }

    /* Avatar styling enhancements */
    & #chat-content img.MuiAvatar-img {
        object-fit: cover;
    }
`;

export const ChatContent = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 16px;
    display: flex;
    flex-direction: column;
`;

export const ChatInputContainer = styled.div`
    width: 100%;
    height: auto;
    min-height: fit-content;
    margin-bottom: 10px;
    overflow: visible;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    padding-top: 10px;
    
    & > div {
        width: 100%;
    }

    & > div > div > textarea{
        max-height: 98px;
        line-height: normal;
        min-height: 44px;
        height: 44px;
        font-size: 14px;
        background: transparent;
        padding: 12px 16px;
        border-radius: 24px;
    }
    
    & > div > div > div > label:first-child{
        display: none;
    }
`;

export const TypingIndicator = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 8px 10px;
    background: ${props => props.theme.colors.primaryWhite || '#F5F7FA'};
    border-radius: 18px;
    width: fit-content;
    margin: 4px 0 8px 0;
    box-shadow: none;
    min-height: 40px;
`;

export const TypingDot = styled.div`
    width: 8px;
    height: 8px;
    background: ${props => props.theme.colors.primary || '#2173FF'};
    border-radius: 50%;
    animation: typing 1s infinite ease-in-out;

    &:nth-child(2) {
        animation-delay: 0.2s;
    }

    &:nth-child(3) {
        animation-delay: 0.4s;
    }

    @keyframes typing {
        0%, 100% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(-5px);
        }
    }
`; 